/**
 * User-facing microcopy for the AskRichard (DataChatbot) surface.
 *
 * One voice: askRichard is a first-person analyst colleague. Copy leads with verbs,
 * stays plain, and uses no em dashes. Centralising the strings here keeps the
 * surface reading as one authored product instead of scattered literals, so a
 * copy change lands in a single place.
 */

export const RICHARD_MICROCOPY = {
  /** Shown while a request is in flight, before the first answer block streams in. */
  thinkingLabel: 'Reading your question…',
  /** Scoped to the version a conversation was born on, never its age — mantle sessions
   *  of any age still run, so "older conversations" would be untrue. */
  readOnlySessionNotice: 'This conversation is from an earlier version of askRichard.',
  /** Standing caveat under the composer. Trust lever: users re-verify most answers. */
  disclaimer: 'askRichard can make mistakes. Verify important figures.',
  /** Empty recent-chats sidebar. */
  emptySidebar: 'No chats yet - ask your first question.',
  /**
   * Composer placeholder while a run streams. Steering is the hero interaction, so the
   * placeholder teaches it by example rather than the flat "Steer the current answer".
   */
  steerPlaceholder: 'Type to steer',
  /** Confirmation shown on a steer interjection once askRichard acts on it (next progress event). */
  steerAdjustedCourse: 'askRichard adjusted course',
  /**
   * One-time coach mark on the first stream (localStorage-gated), teaching that the composer
   * stays live while askRichard works.
   */
  steerCoachMark: 'New: talk to askRichard while it works.',
  /** Badge on the question option askRichard would choose. */
  recommendedBadge: 'Recommended',
  /** Secondary action on a question card: take the recommended option and list it as an assumption. */
  letRichardDecide: 'Let askRichard decide',
  /** Low-emphasis link on a question card that reveals the free-text field. */
  somethingElse: 'Something else',
  /** Submits the free-text answer on a question card. */
  sendAnswer: 'Send',
  /** Quiet reassurance once a create turn has run for 30 seconds. */
  createPatience: 'Usually under two minutes.',
} as const;

/** The steer text rendered as a full-width interjection row: `You steered: "break it down by region"`. */
export function formatSteerLabel(text: string): string {
  return `You steered: "${text.trim()}"`;
}
